import { gql } from "@apollo/client";

export const GET_JOB_BY_ID_WITH_INFO = gql`
    query job($id: Int!) {
        jobLite(id: $id) {
            id
            street1
            street2
            city
            state
            zipcode
            estimatedStartDate
        }
    }
`

export const GET_JOB_BY_ID_WITH_NAME = gql`
    query job($id: Int!) {
        jobLite(id: $id) {
            name
        }
    }
`

export const GET_ALL_JOB_DAYS_FOR_JOB = gql`
    query job($id: Int!) {
        jobLite(id: $id) {
            jobDays {
                id
                date
                startTime
                crewMemberAssignments {
                    id
                }
            }
        }
    }
`

export const GET_JOB_DAYS_FOR_FOREMAN_FOR_JOB = gql`
    query jobDaysForForemanForJob($id: Int!) {
        jobDaysForForemanForJob(id: $id) {
            id
            date
            startTime
            crewMemberAssignments {
                id
            }
        }
    }
`

export const GET_ALL_EQUIPMENT_REQUESTS_FOR_JOB = gql`
    query job($id: Int!) {
        jobLite(id: $id) {
            jobEquipmentRequests {
                id
                datetimeCreated
                equipmentRequestItemsForEquipmentRequest {
                    id
                }
                status
            }
        }
    }
`

export const GET_ALL_JOBS_IN_DATE_RANGE_FOREMAN = gql`
    query jobsInDateRangeForForeman($startDate: Date!, $endDate: Date!) {
        jobsInDateRangeForForeman(startDate: $startDate, endDate: $endDate) {
            id
            name
            street1
            street2
            city
            state
            zipcode
            estimatedStartDate
        }
    }
`

export const GET_ALL_JOBS_FOR_SELECT_FIELD = gql`
    query {
        allJobsLite {
            id
            name
        }
    }
`